var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E5EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.71875C5 6.7959 5.73828 6.03125 6.6875 6.03125H10.168C10.6689 6.03125 11.1436 6.24219 11.5127 6.61133L12.6201 7.71875H16.8125C17.7354 7.71875 18.5 8.4834 18.5 9.40625V16.1562C18.5 17.1055 17.7354 17.8438 16.8125 17.8438H6.6875C5.73828 17.8438 5 17.1055 5 16.1562V7.71875ZM6.6875 7.29688C6.4502 7.29688 6.26562 7.50781 6.26562 7.71875V16.1562C6.26562 16.3936 6.4502 16.5781 6.6875 16.5781H16.8125C17.0234 16.5781 17.2344 16.3936 17.2344 16.1562V9.40625C17.2344 9.19531 17.0234 8.98438 16.8125 8.98438H12.541C12.2773 8.98438 11.9873 8.87891 11.8027 8.69434L10.6162 7.48145C10.4844 7.37598 10.3262 7.29688 10.168 7.29688H6.6875Z",
    fill: "#0047D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.bf455ffd901a9db1b976ad56984d4689.svg";
export { ForwardRef as ReactComponent };